import {
  signInWithEmailAndPassword as signIn,
  getAuth,
  signOut,
  onAuthStateChanged,
  sendEmailVerification,
  sendPasswordResetEmail,
  updatePassword
} from 'firebase/auth';
import { app } from './firebase';
import { LOGIN_SUCCESS, LOGOUT } from 'store/actions';
import { store } from 'store';
import EmailServices from 'notifications/EmailServices';
import UserNotifyFirestoreService from 'views/NotificationManagement/services/NotificationServices';

export const auth = getAuth(app);

onAuthStateChanged(auth, (user) => {
  if (user?.reloadUserInfo) {
    const customAttributes = JSON.parse(user?.reloadUserInfo?.customAttributes);
    if (user && user.emailVerified && customAttributes.isFormatOK) {
      store.dispatch({ type: LOGIN_SUCCESS, user });
    } else {
      store.dispatch({ type: LOGOUT });
    }
  } else {
    store.dispatch({ type: LOGOUT });
  }
});

export const logIn = async (email, password) => {
  try {
    const userCredential = await signIn(auth, email, password);
    const user = userCredential.user;
    const customAttributes = JSON.parse(user?.reloadUserInfo?.customAttributes);

    if (!user.emailVerified) {
      throw new Error('¡Aun no esta validado el email suministrado!');
    }

    if (!customAttributes.preAuthorize) {
      throw new Error('¡El usuario NO ha sido pre-autorizado!');
    }

    store.dispatch({ type: LOGIN_SUCCESS, user });
    return { success: true, user };
  } catch (error) {
    return { success: false, error };
  }
};

export const logOut = async () => {
  try {
    await signOut(auth);
    store.dispatch({ type: LOGOUT });
    return { success: true };
  } catch (error) {
    return { success: false, error };
  }
};

export const sendVerificationEmail = async (email, password) => {
  try {
    const signInResult = await signIn(auth, email, password);

    await sendEmailVerification(signInResult.user);

    const usersToNotify = await UserNotifyFirestoreService.getUserNotify();

    const notificationPromises = usersToNotify.map((user) => EmailServices.createUserNotification(user.email, signInResult.user));

    await Promise.all(notificationPromises);

    return { success: true };
  } catch (error) {
    console.error('Error al enviar el correo electrónico de verificación:', error);
    return { success: false, error };
  }
};

export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return { success: true };
  } catch (error) {
    console.error('Error al enviar el correo electrónico para restablecer la contraseña:', error);
    return { success: false, error };
  }
};

export const updateUserPassword = async (currentPassword, newPassword) => {
  const user = auth.currentUser;

  if (!user) {
    return { success: false, error: new Error('Usuario no autenticado.') };
  }

  try {
    const credential = await signIn(auth, user.email, currentPassword);
    await updatePassword(credential.user, newPassword);
    return { success: true };
  } catch (error) {
    console.error('Error al actualizar la contraseña:', error);
    return { success: false, error };
  }
};
